import {
    takeLatest,
} from 'redux-saga/effects';

import { RELOAD_PAGE } from '../reduxModules/ConsentManagementPlatform';

export function callAction() {
    window.location.reload();
}

export function* watch() {
    yield takeLatest(RELOAD_PAGE, callAction);
}
